import { useState, useCallback } from 'react';

import type { Toast } from '../types';

export const useToast = () => {
  const [toasts, setToasts] = useState<Toast[]>([]);

  const showToast = useCallback(
    (
      message: string,
      type: 'info' | 'success' | 'error' | 'warning' = 'info',
      persistent: boolean = false,
    ): string => {
      const id = Date.now().toString();
      setToasts((prev) => [...prev, { id, message, type }]);

      if (!persistent) {
        setTimeout(() => {
          setToasts((prev) => prev.filter((t) => t.id !== id));
        }, 4000);
      }

      return id;
    },
    [],
  );

  const removeToast = useCallback((id: string) => {
    setToasts((prev) => prev.filter((t) => t.id !== id));
  }, []);

  return { toasts, showToast, removeToast };
};
